import { FormatDateShort, MonthNumberToText } from "utils/dateUtils";
import {
  FormatNumber,
  FormatNumberOrNull,
  FormatNumberWithUnitOrNull
} from "utils/numberUtils";
import { useSelector } from "react-redux";
import { selectState } from "../payroll.slice";

const PrintMonthlyPayroll = () => {

  const { payrollForPrint } = useSelector(selectState);

  return (
    <div className="print-salaries">
      <div className="salaries-date positionFixed">
        <label>{MonthNumberToText(payrollForPrint.month)}</label>
        <label>{payrollForPrint.year}</label>
      </div>
      <div className="salary-content">
        <div className={"single-salary-print"}>
          <h1>{payrollForPrint.employeeName}</h1>
          <p>{payrollForPrint.role}</p>
          <table>
            <tbody>
              <tr>
                <th>br.sati</th>
                <th>din/sat</th>
                <th>ZARADIO</th>
                <th>na račun</th>
                <th>obračun</th>
                <th>datum isp.</th>
                <th>ispl / troš</th>
              </tr>
              <tr>
                <td>
                  <div className="empty">
                    <span className="single-salary-in-input-label align-right">
                      {payrollForPrint.hourlyRateNames?.[0]}:</span>
                    <span className="single-salary-rate-value align-left">
                      {FormatNumberOrNull(payrollForPrint.hourlyWork?.[0]?.hours, {
                        minimumFractionDigits: 0, maximumFractionDigits: 2
                      })}
                    </span>
                  </div>
                </td>
                <td>
                  <div className="empty blue">
                    {FormatNumberOrNull(payrollForPrint.hourlyWork?.[0]?.rate)}
                  </div>
                </td>
                <td>
                  <div className="empty blue">
                    {FormatNumber(payrollForPrint.basicSalary)}
                  </div>
                </td>
                <td>
                  <div className="empty">
                    {FormatNumber(payrollForPrint.paidByBank)}
                  </div>
                </td>
                <td>
                  <div className="empty green">
                    {FormatNumber(payrollForPrint.paidByHand)}
                  </div>
                </td>
                <td>
                  <div className="empty">
                    {FormatDateShort(payrollForPrint.paidOnDate)}
                  </div>
                </td>
                <td>
                  <div className="empty">
                    {payrollForPrint.paidExpenses[0] && (
                      <>
                        {FormatNumberOrNull(payrollForPrint.paidExpenses[0].amount)}
                        <span className="single-salary-in-input-label align-left">
                          {payrollForPrint.paidExpenses[0].note}
                        </span>
                      </>)}
                  </div>
                </td>
              </tr>

              {Array.from(
                Array(Math.max(10, payrollForPrint.hourlyWork.length, payrollForPrint.paidExpenses.length))
                  .keys()).filter(index => index !== 0).map(index => (
                    <tr key={index}>
                      <td>
                        {payrollForPrint.hourlyWork?.[index] ? (
                          <div className="empty">
                            <span className="single-salary-in-input-label align-right">
                              {payrollForPrint.hourlyRateNames?.[index]}:
                            </span>
                            <span className="single-salary-rate-value align-left">
                              {FormatNumberOrNull(payrollForPrint.hourlyWork?.[index]?.hours, {
                                minimumFractionDigits: 0, maximumFractionDigits: 2
                              })}
                            </span>
                          </div>
                        ) : <></>}
                      </td>
                      <td>
                        {payrollForPrint.hourlyWork?.[index] ? (
                          <div className="empty">
                            {FormatNumberOrNull(payrollForPrint.hourlyWork?.[index]?.rate)}
                          </div>) : <></>}
                      </td>
                      {index === 2 ? (
                        <>
                          <td className="span-two-columns">
                            <span className="single-salary-item-label align-right">UKUPNO ZARADIO: </span>
                            <span className="single-salary-item-value">
                              {FormatNumber(payrollForPrint.totalAmountEarned)}
                            </span>
                          </td>
                          <td className="span-three-columns-and-rows">
                            <div className="single-salary-item-note">
                              {payrollForPrint.note.split("\n").filter(line => line).map((line, index) => (
                                <p key={index}>
                                  {line}
                                  <br />
                                </p>
                              ))}
                            </div>
                          </td>
                        </>
                      )
                        : index === 3 ? (
                          <td className="span-two-columns">
                            <span className="single-salary-item-label align-right">bonus: </span>
                            <span className="single-salary-item-value">
                              {FormatNumber(payrollForPrint.bonus)}
                            </span>
                          </td>
                        )
                          : index === 4 ? (
                            <td className="span-two-columns">
                              <span className="single-salary-item-label align-right">prevoz: </span>
                              <span className="single-salary-item-value">
                                {FormatNumber(payrollForPrint.travelExpenses)}
                              </span>
                            </td>
                          )
                            : index === 5 ? (
                              <td className="span-two-columns">
                                <span className="single-salary-item-label align-right">korekcija: </span>
                                <span className="single-salary-item-value">
                                  {FormatNumber(payrollForPrint.correction)}
                                </span>
                              </td>
                            )
                              :
                              <><td></td><td></td></>}
                      <td></td>
                      <td></td>
                      <td>
                        {payrollForPrint.paidExpenses?.[index] !== undefined ? (
                          <div className="empty">
                            {FormatNumberOrNull(payrollForPrint.paidExpenses?.[index].amount)}
                            <span className="single-salary-in-input-label align-left">
                              {payrollForPrint.paidExpenses?.[index].note}
                            </span>
                          </div>
                        ) : <></>}
                      </td>
                    </tr>
                  ))}

            </tbody>
          </table>
          <div className="single-salary-counters-container">
            <div className="single-salary-counters-column">
              <span>
                <div>{FormatNumberOrNull(payrollForPrint.regularBreakfasts)}</div>doručak
              </span>
              <span>
                <div>{FormatNumberOrNull(payrollForPrint.regularLunches)}</div>ručak
              </span>
              <span>
                <div>{FormatNumberOrNull(payrollForPrint.regularDinners)}</div>večera
              </span>
              <span>
              </span>
            </div>

            <div className="single-salary-counters-column">
              <span>
                <div>{FormatNumberOrNull(payrollForPrint.cashBreakfasts)}</div>keš doručak
              </span>
              <span>
                <div>{FormatNumberOrNull(payrollForPrint.cashLunches)}</div>keš ručak
              </span>
              <span>
                <div>{FormatNumberOrNull(payrollForPrint.cashDinners)}</div>keš večera
              </span>
              <span>
              </span>
            </div>

            <div className="single-salary-counters-column">
              <span>
                <div>
                  {FormatNumberOrNull(payrollForPrint.vacationDays)}
                </div>dana odmora
              </span>
              <span>
                <div>
                  {FormatNumberOrNull(payrollForPrint.sickLeaveDays)}
                </div>dana bolovanja
              </span>
              <span>
                <div>
                  {FormatNumberWithUnitOrNull(payrollForPrint.effectiveKilometers, 'km')}
                </div>efektivno
              </span>
              <span>
                <div>
                  {FormatNumberWithUnitOrNull(payrollForPrint.effectiveHours, 'sati')}
                </div>efektivno
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintMonthlyPayroll;
